import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

const rowStyle = (theme: Theme) => css({
  borderBottom: `1px solid ${theme.reportColors.borderPrimary}`,
  breakInside: 'avoid',
  color: theme.reportColors.textPrimary,

  'tbody &:nth-of-type(2n)': {
    background: theme.reportColors.tableRowBackgroundPrimary,
  },
  'tbody &:nth-of-type(2n + 1)': {
    background: theme.reportColors.tableRowBackgroundSecondary,
  },
});

const tableDataCellStyle = () => (theme: Theme) => css({
  textAlign: 'right',
  border: `0 solid ${theme.reportColors.borderPrimary}`,
  padding: 5,
  borderTopWidth: 0,
  borderBottomWidth: 0,
  '&:first-of-type': {
    borderLeftWidth: 1,
    textAlign: 'left',
  },
  '&:last-of-type': {
    borderRightWidth: 1,
  },
  'tr:first-of-type &': {
    borderTopWidth: 1,
  },
  'tr:last-of-type &': {
    borderBottomWidth: 1,
  },
  'tr:first-of-type &:first-of-type': {
    borderRadius: '8px 0 0 0',
  },
  'tr:last-of-type &:first-of-type': {
    borderRadius: '0 0 0 8px',
  },
  'tr:first-of-type &:last-of-type': {
    borderRadius: '0 8px 0 0',
  },
  'tr:last-of-type &:last-of-type': {
    borderRadius: '0 0 8px 0',
  },
});

type ExportReportTableDataRowProps = Readonly<{
  label: string;
  values: ReadonlyArray<string>;
}>;

export const ExportReportTableDataRowComponent = (props: ExportReportTableDataRowProps) => {
  return (
    <tr css={rowStyle}>
      <td css={tableDataCellStyle}>
        {props.label}
      </td>
      {props.values.map((value, index) => (
        <td key={index} css={tableDataCellStyle}>
          {value}
        </td>
      ))}
    </tr>
  );
};
